import RegistrationTrackingReportComponent from "../Components/MHL_Reports/RegistrationTrackingReportComponent"

function RegistrationTrackingReportPage() {
    return (

        <RegistrationTrackingReportComponent/>
    )
}

export default RegistrationTrackingReportPage